/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AudioLibraryRouteImport } from './routes/audio-library'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ProjectsRouteImport } from './routes/projects'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as TopUpRouteImport } from './routes/top-up'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as CreateIndexRouteImport } from './routes/create/index'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AudioLibraryRoute = AudioLibraryRouteImport.update({
  id: '/audio-library',
  path: '/audio-library',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const PricingRoute = PricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsRoute = ProjectsRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const TopUpRoute = TopUpRouteImport.update({
  id: '/top-up',
  path: '/top-up',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const CreateIndexRoute = CreateIndexRouteImport.update({
  id: '/create/',
  path: '/create/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/audio-library': typeof AudioLibraryRoute
  '/dashboard': typeof DashboardRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/pricing': typeof PricingRoute
  '/privacy': typeof PrivacyRoute
  '/projects': typeof ProjectsRoute
  '/reset-password': typeof ResetPasswordRoute
  '/settings': typeof SettingsRoute
  '/signup': typeof SignupRoute
  '/terms': typeof TermsRoute
  '/top-up': typeof TopUpRoute
  '/verify-email': typeof VerifyEmailRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/create/': typeof CreateIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/audio-library': typeof AudioLibraryRoute
  '/dashboard': typeof DashboardRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/pricing': typeof PricingRoute
  '/privacy': typeof PrivacyRoute
  '/projects': typeof ProjectsRoute
  '/reset-password': typeof ResetPasswordRoute
  '/settings': typeof SettingsRoute
  '/signup': typeof SignupRoute
  '/terms': typeof TermsRoute
  '/top-up': typeof TopUpRoute
  '/verify-email': typeof VerifyEmailRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/create': typeof CreateIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/audio-library': typeof AudioLibraryRoute
  '/dashboard': typeof DashboardRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/pricing': typeof PricingRoute
  '/privacy': typeof PrivacyRoute
  '/projects': typeof ProjectsRoute
  '/reset-password': typeof ResetPasswordRoute
  '/settings': typeof SettingsRoute
  '/signup': typeof SignupRoute
  '/terms': typeof TermsRoute
  '/top-up': typeof TopUpRoute
  '/verify-email': typeof VerifyEmailRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/create/': typeof CreateIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/audio-library'
    | '/dashboard'
    | '/forgot-password'
    | '/login'
    | '/pricing'
    | '/privacy'
    | '/projects'
    | '/reset-password'
    | '/settings'
    | '/signup'
    | '/terms'
    | '/top-up'
    | '/verify-email'
    | '/auth/callback'
    | '/create/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/audio-library'
    | '/dashboard'
    | '/forgot-password'
    | '/login'
    | '/pricing'
    | '/privacy'
    | '/projects'
    | '/reset-password'
    | '/settings'
    | '/signup'
    | '/terms'
    | '/top-up'
    | '/verify-email'
    | '/auth/callback'
    | '/create'
  id:
    | '__root__'
    | '/'
    | '/audio-library'
    | '/dashboard'
    | '/forgot-password'
    | '/login'
    | '/pricing'
    | '/privacy'
    | '/projects'
    | '/reset-password'
    | '/settings'
    | '/signup'
    | '/terms'
    | '/top-up'
    | '/verify-email'
    | '/auth/callback'
    | '/create/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AudioLibraryRoute: typeof AudioLibraryRoute
  DashboardRoute: typeof DashboardRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  PricingRoute: typeof PricingRoute
  PrivacyRoute: typeof PrivacyRoute
  ProjectsRoute: typeof ProjectsRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SettingsRoute: typeof SettingsRoute
  SignupRoute: typeof SignupRoute
  TermsRoute: typeof TermsRoute
  TopUpRoute: typeof TopUpRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  CreateIndexRoute: typeof CreateIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audio-library': {
      id: '/audio-library'
      path: '/audio-library'
      fullPath: '/audio-library'
      preLoaderRoute: typeof AudioLibraryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pricing': {
      id: '/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof PricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects': {
      id: '/projects'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof ProjectsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/top-up': {
      id: '/top-up'
      path: '/top-up'
      fullPath: '/top-up'
      preLoaderRoute: typeof TopUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/create/': {
      id: '/create/'
      path: '/create'
      fullPath: '/create/'
      preLoaderRoute: typeof CreateIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AudioLibraryRoute: AudioLibraryRoute,
  DashboardRoute: DashboardRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  PricingRoute: PricingRoute,
  PrivacyRoute: PrivacyRoute,
  ProjectsRoute: ProjectsRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SettingsRoute: SettingsRoute,
  SignupRoute: SignupRoute,
  TermsRoute: TermsRoute,
  TopUpRoute: TopUpRoute,
  VerifyEmailRoute: VerifyEmailRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  CreateIndexRoute: CreateIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
